import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import type { QTableProps } from 'quasar';

interface Props<T = unknown> {
  rows: T[];
  columns: QTableProps['columns'];
  loading?: boolean;
  rowsPerPageOptions?: number[];
  flat?: boolean;
  bordered?: boolean;
  virtualScroll?: boolean;
  stickyHeader?: boolean;
  dense?: boolean;
  maxHeight?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DSTable',
  props: {
    rows: {},
    columns: {},
    loading: { type: Boolean, default: false },
    rowsPerPageOptions: { default: () => [25, 50, 100] },
    flat: { type: Boolean, default: true },
    bordered: { type: Boolean, default: true },
    virtualScroll: { type: Boolean, default: true },
    stickyHeader: { type: Boolean, default: true },
    dense: { type: Boolean, default: true },
    maxHeight: { default: '400px' }
  },
  setup(__props: any) {

const props = __props;



const tableStyle = computed(() => ({
  maxHeight: props.maxHeight,
}));

return (_ctx: any,_cache: any) => {
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, _mergeProps(_ctx.$attrs, {
    rows: _ctx.rows,
    columns: _ctx.columns,
    loading: _ctx.loading,
    "rows-per-page-options": _ctx.rowsPerPageOptions,
    flat: _ctx.flat,
    bordered: _ctx.bordered,
    "virtual-scroll": _ctx.virtualScroll,
    style: tableStyle.value,
    class: ["ds-table", {
      'ds-table--sticky': _ctx.stickyHeader,
      'ds-table--dense': _ctx.dense,
    }]
  }), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope || {})))
        ])
      }
    })
  ]), 1040, ["rows", "columns", "loading", "rows-per-page-options", "flat", "bordered", "virtual-scroll", "style", "class"]))
}
}

})